'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalShodoCertChainRequest(origin) {
  this.wA = null;
  this.wA = origin;
}
export { $c_Lpresto_AgentView$LocalShodoCertChainRequest as $c_Lpresto_AgentView$LocalShodoCertChainRequest };
$p = $c_Lpresto_AgentView$LocalShodoCertChainRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalShodoCertChainRequest;
/** @constructor */
function $h_Lpresto_AgentView$LocalShodoCertChainRequest() {
}
export { $h_Lpresto_AgentView$LocalShodoCertChainRequest as $h_Lpresto_AgentView$LocalShodoCertChainRequest };
$h_Lpresto_AgentView$LocalShodoCertChainRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$LocalShodoCertChainRequest) && (this.wA === x$0.wA)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "LocalShodoCertChainRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.wA;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.pm = (function() {
  return this.wA;
});
function $isArrayOf_Lpresto_AgentView$LocalShodoCertChainRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hH)));
}
export { $isArrayOf_Lpresto_AgentView$LocalShodoCertChainRequest as $isArrayOf_Lpresto_AgentView$LocalShodoCertChainRequest };
var $d_Lpresto_AgentView$LocalShodoCertChainRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalShodoCertChainRequest, "presto.AgentView$LocalShodoCertChainRequest", ({
  hH: 1,
  b5: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalShodoCertChainRequest as $d_Lpresto_AgentView$LocalShodoCertChainRequest };
//# sourceMappingURL=presto.-Agent-View$-Local-Shodo-Cert-Chain-Request.js.map
